/**
 * Consumer booking status presentation mapping.
 *
 * Mirrors the customer mobile app `BookingScreen.getStatusInfo` so every
 * consumer-facing surface (dashboard, list, history, detail) renders identical
 * label + color for the same backend status.
 */

export type ConsumerBookingStatusPresentation = {
  label: string;
  backgroundColor: string;
  textColor: string;
};

const titleCase = (raw: string) =>
  raw ? raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase() : raw;

/** Customer app `BookingScreen` getStatusInfo — label + badge colors. */
export function consumerBookingStatusPresentation(
  status: string
): ConsumerBookingStatusPresentation {
  const statusLower = (status || '').toLowerCase();
  if (statusLower === 'requested' || statusLower === 'pending') {
    return { label: 'Request', backgroundColor: '#2196F3', textColor: '#fff' };
  }
  if (
    statusLower === 'upcoming' ||
    statusLower === 'accepted' ||
    statusLower === 'confirmed'
  ) {
    return { label: 'Upcoming', backgroundColor: '#FE9300', textColor: '#fff' };
  }
  if (
    statusLower === 'ongoing' ||
    statusLower === 'start_job' ||
    statusLower === 'in_progress'
  ) {
    return { label: 'Ongoing', backgroundColor: '#2A9C00', textColor: '#fff' };
  }
  if (
    statusLower === 'rejected' ||
    statusLower === 'refused' ||
    statusLower === 'canceled' ||
    statusLower === 'cancelled'
  ) {
    return {
      label: titleCase(status || ''),
      backgroundColor: '#FF0000',
      textColor: '#fff',
    };
  }
  if (statusLower === 'completed') {
    return {
      label: 'Completed',
      backgroundColor: '#000000',
      textColor: '#fff',
    };
  }
  return {
    label: titleCase(status || ''),
    backgroundColor: '#FE9300',
    textColor: '#fff',
  };
}
